import axiosServices from "../utils/axios";

export const fetchGates = async () => {
  const response = await axiosServices.get(`/gates`);
  return response.data.data;
};

export const updateGatesList = async (gate_id: string,   data: {
    [key: string]: any;
    gate_id: string;
  }) => {
  const requestData = { ...data};

  if (data.lat !== undefined && data.lng !== undefined) {
    requestData.pindrop = {
      type: "Point",
      coordinates: [data.lng, data.lat],
    }
    requestData.gate_id = gate_id;
  }
  const response = await axiosServices.put(`/gates/${gate_id}`, requestData);
  const payload = response?.data?.data;
  let updated: any = payload;
  if (Array.isArray(payload) && payload.length >= 2 && Array.isArray(payload[1])) {
    updated = payload[1][0];
  }
  if (updated && !updated.gate_id) {
    if (updated.id) {
      updated.gate_id = updated.id;
    } else {
      updated.gate_id = gate_id;
    }
  }
  return updated;
};

export const deleteGatesData = async (id: string) => {
  const response = await axiosServices.delete(`/gates/${id}`);
  return { success: response?.data?.success, id };
};

export const addGatesData = async (data: { [key: string]: any }) => {
  const response = await axiosServices.post(`/gates`, data);
  return response?.data?.data;
};
